import { CSSProperties } from 'react';

import { InputType as JoyInputType } from 'core/enums';

import { Visible } from 'coreOld/components';
import { Label } from 'coreOld/elements';
import { InputType, Position } from 'coreOld/enums';

import { InputWrapper } from './fieldStyle';
import InputField from './InputField';

interface IProps {
  htmlFor?: string;
  name?: string;
  label?: string;
  labelPosition?: Position;
  required?: boolean;
  type: InputType | JoyInputType;
  hidden?: boolean;
  fullWidth?: boolean;
  inputProps?: Record<string, any>;
  wrapperStyle?: CSSProperties;
}

const FieldView = ({
  htmlFor,
  name,
  label,
  labelPosition,
  required,
  type,
  hidden = false,
  fullWidth = true,
  inputProps,
  wrapperStyle,
}: IProps) => {
  return (
    <InputWrapper
      labelPosition={labelPosition}
      fullWidth={fullWidth}
      hidden={hidden}
      style={wrapperStyle}
    >
      <Visible when={Boolean(label)}>
        <Label label={label} htmlFor={htmlFor} required={required} labelPosition={labelPosition} />
      </Visible>

      <InputField name={name} type={type} inputProps={inputProps} />
    </InputWrapper>
  );
};

export default FieldView;
